import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faBoxOpen,
  faStore,
  faBoxes,
  faCogs,
  faChartLine,
  faUsers,
  faCoins,
  faTelevision,
  faFile,
  faSpaghettiMonsterFlying,
  faCreditCard,
  faBoxesStacked,
} from "@fortawesome/free-solid-svg-icons";
import { BsCreditCard2BackFill } from "react-icons/bs";

export const menusFull = [
  {
    title: "ສະຖິຕິ",
    path: "/dashboard",
    icon: <FontAwesomeIcon icon={faChartLine} />,
    cName: "nav-text",
  },

  {
    title: "ຈັດການ ໄລຟ",
    path: "/live-manage/active/limit/30/page/1",
    icon: <FontAwesomeIcon icon={faVideo} />,
    cName: "nav-text",
  },
  {
    title: "ຈັດການ ໂພສ",
    path: "/post-feed",
    icon: <FontAwesomeIcon icon={faCoins} />,
    cName: "nav-text",
  },
  {
    title: "ສິນຄ້າ",
    path: "/products/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faBoxOpen} />,
    cName: "nav-text",
  },
  {
    title: "ແບນເນີ",
    path: "/advertising-sale-page",
    icon: <FontAwesomeIcon icon={faTelevision} />,
    cName: "nav-text",
  },
  {
    title: "ເຄຣດິດ",
    path: "/wallet_store/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faCreditCard} />,
    cName: "nav-text",
  },
  {
    title: "ຈັດການອໍເດີ້ເຂົ້າ",
    path: "/orders/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faBoxes} />,
    cName: "nav-text",
  },
  {
    title: "ອໍເດີ້ຈາກເຊວເພຈ",
    path: "/invoices/create-invoice",
    icon: <FontAwesomeIcon icon={faBoxesStacked} />,
    cName: "nav-text",
  },
  {
    title: " ລູກຄ້າຊີເອຟ",
    path: "/user-cf",
    icon: <FontAwesomeIcon icon={faUsers} />,
    cName: "nav-text",
  },

  {
    title: "ຕັ້ງຄ່າລະບົບ",
    path: "/settings",
    icon: <FontAwesomeIcon icon={faCogs} />,
    cName: "nav-text",
  },
];

export const menuSalePage = [
  {
    title: "ສະຖິຕິ",
    path: "/dashboard",
    icon: <FontAwesomeIcon icon={faChartLine} />,
    cName: "nav-text",
  },

  {
    title: "ຈັດການສິນຄ້າ",
    path: "/products/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faBoxOpen} />,
    cName: "nav-text",
  },
  {
    title: "ແບນເນີ",
    path: "/advertising-sale-page",
    icon: <FontAwesomeIcon icon={faTelevision} />,
    cName: "nav-text",
  },
  {
    title: "ອໍເດີ້ເຊວເພຈ",
    path: "/invoices/create-invoice",
    icon: <FontAwesomeIcon icon={faSpaghettiMonsterFlying} />,
    cName: "nav-text",
  },

  {
    title: "ຕັ້ງຄ່າ",
    path: "/settings",
    icon: <FontAwesomeIcon icon={faCogs} />,
    cName: "nav-text",
  },
];

export const menuLive = [
  {
    title: "ສະຖິຕິ",
    path: "/dashboard",
    icon: <FontAwesomeIcon icon={faChartLine} />,
    cName: "nav-text",
  },

  {
    title: "ຈັດການໄລຟ",
    path: "/live-manage/active/limit/30/page/1",
    icon: <FontAwesomeIcon icon={faVideo} />,
    cName: "nav-text",
  },
  {
    title: "ຈັດການ Feed",
    path: "/post-feed",
    icon: <FontAwesomeIcon icon={faCoins} />,
    cName: "nav-text",
  },
  {
    title: "ຈັດການສິນຄ້າ",
    path: "/products/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faBoxOpen} />,
    cName: "nav-text",
  },
  {
    title: "ອໍເດີ້ທັງໝົດ",
    path: "/orders/limit/50/page/1",
    icon: <FontAwesomeIcon icon={faBoxes} />,
    cName: "nav-text",
  },
  {
    title: " ລູກຄ້າຊີເອຟ",
    path: "/user-cf",
    icon: <FontAwesomeIcon icon={faUsers} />,
    cName: "nav-text",
  },

  {
    title: "ຕັ້ງຄ່າ",
    path: "/settings",
    icon: <FontAwesomeIcon icon={faCogs} />,
    cName: "nav-text",
  },
];
